import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Audit, Action, PlantAndManagement, Question } from 'types/BarrierModal'

const initialState: Audit = {} as Audit

const barrierFormDataSlice = createSlice({
  name: 'formData',
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<Partial<Audit>>) => {
      Object.assign(state, action.payload)
    },
    addAction: (state, action: PayloadAction<{ formKey: 'plant' | 'management', barrieId: number }>) => {
      const { formKey, barrieId } = action.payload
      if (state[formKey]) {
        state[formKey].actions.push({
          id: null,
          action: '',
          event: '',
          location: '',
          priority: null,
          status: 'OPEN',
          due_date: null,
          progress_percent: '0',
          finding: '',
          // barriers_ids: [barrieId],
          // base_barrier_id: barrieId,
          base_action_id: null,
          isNewRecord: true,
        })
      } else {
        state[formKey].actions = [
          {
            id: null,
            action: '',
            event: '',
            location: '',
            priority: null,
            status: 'OPEN',
            due_date: null,
            progress_percent: '0',
            finding: '',
            // barriers_ids: [barrieId],
            // base_barrier_id: barrieId,
            base_action_id: null,
            isNewRecord: true,
          },
        ]
      }
    },
    updateBarrierQuestionData: (state, action: PayloadAction<{formKey: 'plant' | 'management', q_index: number, data: Partial<Question>}>) =>{
      const { formKey, q_index, data} = action.payload
      state[formKey].questions[q_index] = {...state[formKey].questions[q_index], ...data}
    },
    deleteAction: (
      state,
      action: PayloadAction<{ formKey: 'plant' | 'management'; action_id?: string; index: number }>
    ) => {
      const { formKey, action_id, index } = action.payload
      if (action_id) {
        const index = state[formKey].actions.findIndex((action) => action.id === action_id)
        if (index !== -1) {
          state[formKey].actions.splice(index, 1)
        }
      } else {
        state[formKey].actions.splice(index, 1)
      }
    },
    deleteObservationAction: (
      state,
      action: PayloadAction<{
        formKey: 'plant' | 'management'
        questionIdx: number
        obsIdx: number
        actionIdx: number
        action_id?: string
      }>
    ) => {
      const { formKey, action_id, questionIdx, obsIdx, actionIdx } = action.payload
      if (action_id) {
        const index = state[formKey].questions[questionIdx].observations[obsIdx].actions.findIndex(
          (action) => action.id === action_id
        )
        if (index !== -1) {
          state[formKey].questions[questionIdx].observations[obsIdx].actions.splice(index, 1)
        }
      } else {
        state[formKey].questions[questionIdx].observations[obsIdx].actions.splice(actionIdx, 1)
      }
    },
    setFormTypeData: (
      state,
      action: PayloadAction<{ formKey: 'plant' | 'management'; data: Partial<PlantAndManagement> }>
    ) => {
      const { data, formKey } = action.payload
      state[formKey] = { ...state[formKey], ...data }
    },
    addQuestionAction: (
      state,
      action: PayloadAction<{ formKey: 'plant' | 'management'; index: number }>
    ) => {
      const { formKey, index } = action.payload
      if (state[formKey].questions[index]) {
        state[formKey].questions[index].observations.push({
          id: null,
          answer: '',
          attachments: [],
          actions: [],
        })
      } else {
        state[formKey].questions[index].observations = [
          { id: null, answer: '', attachments: [], actions: [] },
        ]
      }
    },
    addObservationActions: (
      state,
      action: PayloadAction<{
        formKey: 'plant' | 'management'
        questionIdx: number
        obsIdx: number
        defaultBarrier: number
      }>
    ) => {
      const { formKey, questionIdx, obsIdx, defaultBarrier } = action.payload
      if (state[formKey].questions[questionIdx].observations[obsIdx].actions) {
        state[formKey].questions[questionIdx].observations[obsIdx].actions.push({
          id: null,
          action: '',
          event: '',
          location: '',
          priority: null,
          status: 'OPEN',
          due_date: null,
          progress_percent: '0',
          finding: '',
          isNewRecord: true,
          // barriers_ids: [defaultBarrier],
          // base_barrier_id: defaultBarrier,
        })
      } else {
        state[formKey].questions[questionIdx].observations[obsIdx].actions = [
          {
            id: null,
            action: '',
            event: '',
            location: '',
            priority: null,
            status: 'OPEN',
            due_date: null,
            progress_percent: '0',
            finding: '',
            isNewRecord: true,
            // barriers_ids: [defaultBarrier],
            // base_barrier_id: defaultBarrier,
          },
        ]
      }
    },
    updateObservationActions: (
      state,
      action: PayloadAction<{
        formKey: 'plant' | 'management'
        questionIdx: number
        obsIdx: number
        actionIdx: number
        actionData: Action
      }>
    ) => {
      const { formKey, questionIdx, obsIdx, actionIdx, actionData } = action.payload
      if (state[formKey]?.questions[questionIdx]?.observations[obsIdx]?.actions[actionIdx]) {
        state[formKey].questions[questionIdx].observations[obsIdx].actions[actionIdx] = actionData
      } else {
        state[formKey].questions[questionIdx].observations[obsIdx].actions = [actionData]
      }
    },
    deleteQuestionAction: (
      state,
      action: PayloadAction<{
        formKey: 'plant' | 'management'
        questionIndex: number
        index: number
      }>
    ) => {
      const { formKey, questionIndex, index } = action.payload
      if (state[formKey] && state[formKey].questions[questionIndex]) {
        state[formKey].questions[questionIndex].observations.splice(index, 1)
      }
      if (state[formKey].questions[questionIndex].observations?.length === 0) {
        state[formKey].questions[questionIndex].observations = []
      }
    },
  },
})

export const {
  addAction,
  setFormData,
  deleteAction,
  setFormTypeData,
  addQuestionAction,
  deleteQuestionAction,
  addObservationActions,
  deleteObservationAction,
  updateObservationActions,
  updateBarrierQuestionData
} = barrierFormDataSlice.actions
export default barrierFormDataSlice.reducer
